const languages = [
  {
    id: "AF",
    value: "Afrikaans"
  },
  {
    id: "AM",
    value: "Amharic"
  },
  {
    id: "AR",
    value: "Arabic"
  },
  {
    id: "AS",
    value: "Assamese"
  },
  {
    id: "AZ",
    value: "Azerbaijani"
  },
  {
    id: "BE",
    value: "Byelorussian"
  },
  {
    id: "BG",
    value: "Bulgarian"
  },
  {
    id: "BN",
    value: "Bengali; Bangla"
  },
  {
    id: "BO",
    value: "Tibetan"
  },
  {
    id: "CA",
    value: "Catalan"
  },
  {
    id: "CS",
    value: "Czech"
  },
  {
    id: "CY",
    value: "Welsh"
  },
  {
    id: "DA",
    value: "Danish"
  },
  {
    id: "DE",
    value: "German"
  },
  {
    id: "EL",
    value: "Greek"
  },
  {
    id: "EN",
    value: "English"
  },
  {
    id: "ES",
    value: "Spanish"
  },
  {
    id: "ET",
    value: "Estonian"
  },
  {
    id: "EU",
    value: "Basque"
  },
  {
    id: "FA",
    value: "Persian"
  },
  {
    id: "FI",
    value: "Finnish"
  },
  {
    id: "FO",
    value: "Faeroese"
  },
  {
    id: "FR",
    value: "French"
  },
  {
    id: "GA",
    value: "Irish"
  },
  {
    id: "GL",
    value: "Galician"
  },
  {
    id: "GSW",
    value: "Swiss German"
  },
  {
    id: "GU",
    value: "Gujarati"
  },
  {
    id: "GV",
    value: "Manx"
  },
  {
    id: "HA",
    value: "Hausa"
  },
  {
    id: "HAW",
    value: "Hawaiian"
  },
  {
    id: "HE",
    value: "Hebrew"
  },
  {
    id: "HI",
    value: "Hindi"
  },
  {
    id: "HR",
    value: "Croatian"
  },
  {
    id: "HU",
    value: "Hungarian"
  },
  {
    id: "HY",
    value: "Armenian"
  },
  {
    id: "ID",
    value: "Indonesian"
  },
  {
    id: "II",
    value: "Sichuan Yi"
  },
  {
    id: "IN",
    value: "Indonesian"
  },
  {
    id: "IS",
    value: "Icelandic"
  },
  {
    id: "IT",
    value: "Italian"
  },
  {
    id: "IW",
    value: "Hebrew"
  },
  {
    id: "JA",
    value: "Japanese"
  },
  {
    id: "KA",
    value: "Georgian"
  },
  {
    id: "KK",
    value: "Kazakh"
  },
  {
    id: "KL",
    value: "Greenlandic"
  },
  {
    id: "KM",
    value: "Cambodian"
  },
  {
    id: "KN",
    value: "Kannada"
  },
  {
    id: "KO",
    value: "Korean"
  },
  {
    id: "KOK",
    value: "Konkani"
  },
  {
    id: "KW",
    value: "cornish"
  },
  {
    id: "LT",
    value: "Lithuanian"
  },
  {
    id: "LV",
    value: "Latvian"
  },
  {
    id: "MK",
    value: "Macedonian"
  },
  {
    id: "ML",
    value: "Malayalam"
  },
  {
    id: "MR",
    value: "Marathi"
  },
  {
    id: "MS",
    value: "Malay"
  },
  {
    id: "MT",
    value: "Maltese"
  },
  {
    id: "NB",
    value: "Norwegian Bokmål"
  },
  {
    id: "NE",
    value: "Nepali"
  },
  {
    id: "NL",
    value: "Dutch"
  },
  {
    id: "NN",
    value: "Norwegian Nynorsk"
  },
  {
    id: "NO",
    value: "Norwegian"
  },
  {
    id: "OM",
    value: "(Afan) Oromo"
  },
  {
    id: "OR",
    value: "Oriya"
  },
  {
    id: "PA",
    value: "Punjabi"
  },
  {
    id: "PL",
    value: "Polish"
  },
  {
    id: "PS",
    value: "Pashto, Pushto"
  },
  {
    id: "PT",
    value: "Portuguese"
  },
  {
    id: "RO",
    value: "Romanian"
  },
  {
    id: "RU",
    value: "Russian"
  },
  {
    id: "SH",
    value: "Serbo-Croatian"
  },
  {
    id: "SI",
    value: "Singhalese"
  },
  {
    id: "SK",
    value: "Slovak"
  },
  {
    id: "SL",
    value: "Slovenian"
  },
  {
    id: "SO",
    value: "Somali"
  },
  {
    id: "SQ",
    value: "Albanian"
  },
  {
    id: "SR",
    value: "Serbian"
  },
  {
    id: "SV",
    value: "Swedish"
  },
  {
    id: "SW",
    value: "Swahili"
  },
  {
    id: "TA",
    value: "Tamil"
  },
  {
    id: "TE",
    value: "Tegulu"
  },
  {
    id: "TH",
    value: "Thai"
  },
  {
    id: "TI",
    value: "Tigrinya"
  },
  {
    id: "TR",
    value: "Turkish"
  },
  {
    id: "UK",
    value: "Ukrainian"
  },
  {
    id: "UR",
    value: "Urdu"
  },
  {
    id: "UZ",
    value: "Uzbek"
  },
  {
    id: "VI",
    value: "Vietnamese"
  },
  {
    id: "ZH",
    value: "Chinese"
  },
  {
    id: "ZU",
    value: "Zulu"
  }
];

export default languages;
